import './eventdetail.less'
import {classes} from '@codeurs/front'
import m from 'mithril'
import {getThemesAndTagsFromLists} from 'util/tags'
import ContentContainer from 'views/layout/contentcontainer'
import Link from 'views/layout/link'
import ContentPage from 'views/pages/contentpage'
import {ArticleType} from 'views/partials/features/articlelink'
import ArticlesContainer from 'views/partials/features/articlescontainer'
import Share from 'views/partials/share'
import TagLink from 'views/layout/taglink'
import {PublicationType} from '../partials/features/publicationlink'
import FeaturedPublication from '../partials/features/featuredpublication'
import Spacer from 'views/partials/spacer'
import SideInfo from '../partials/features/sideinfo'
import {format} from 'date-fns'
import RegisterForm from '../../forms/registerform'
import EventImage from '../partials/events/eventimage'

export default class EventDetail extends ContentPage<{
	sector: Array<string>
	policy: Array<string>
	tags: Array<string>
	lists: any
	related: {articles: Array<ArticleType>}
	address: string
	postal: string
	city: string
	country: Array<string>
	venue: string
	start_date: string
	end_date: string
	form_add?: boolean
	form_fields?: Array<string>
}> {
	viewContent() {
		const {
			related,
			channel,
			form_add,
			form_fields,
			title,
			path,
			id,
			links
		} = this.attrs.data
		return [
			form_add
				? m(RegisterForm, {
						title,
						path,
						id,
						links,
						fields: form_fields
				  })
				: null,
			m('.eventdetail-bottom',
				m(ContentContainer, [
					m('.eventdetail-bottom-content', [
						this.tagsView(),
						m('.eventdetail-bottom-content-links', m(Share, {mod: 'rounded'}))
					]),
					m(Spacer),
					m(ArticlesContainer, {related, mod: 'articledetail', channel})
				])
			)
		]
	}
	tagsView() {
		const {sector, policy, tags, lists} = this.attrs.data
		return m('.article-bottom-content-tags',
			getThemesAndTagsFromLists(lists, policy, sector, tags).map(tag =>
				m(TagLink, {text: tag, mod: 'bigtag'})
			)
		)
	}

	viewAttachedPublication() {
		const {
			venue,
			address,
			postal,
			city,
			country,
			lists,
			start_date
		} = this.attrs.data

		return m(SideInfo,
			{
				title: 'Info',
				start_date
			},
			m('.eventdetail-venue',
				m('.eventdetail-venue-content', [
					m('.eventdetail-venue-date', this.viewInfoDates()),
					venue && m('', venue),
					this.viewAddress()
				])
			)
		)
	}

	viewInfoDates() {
		let {start_date, end_date} = this.attrs.data
		if (!start_date && !end_date) return null
		if (!start_date) start_date = end_date

		let dateFormat = 'dddd MMM. Do, YYYY'
		let hourFormat = 'HH:mm'

		const startDate = format(start_date, dateFormat)
		const startTime = format(start_date, hourFormat)

		if (!end_date || start_date === end_date) {
			if (format(start_date, 'hm') !== '00')
				return [m('', startDate), startTime !== '00:00' && m('', startTime)]
		}

		const endDate = format(end_date, dateFormat)
		const endTime = format(end_date, hourFormat)
		const showTime = startTime !== '00:00' || endTime !== '00:00'

		if (startDate === endDate) {
			return [m('', startDate), showTime && m('', startTime + ' - ' + endTime)]
		}

		return [
			m('', 'Begin: ' + startDate),
			showTime && m('', 'at ' + startTime),
			m('', 'End: ' + endDate),
			showTime && m('', 'at ' + endTime)
		]
	}

	viewAddress() {
		const {address, postal, city, country, lists} = this.attrs.data
		let cityLine = ''
		let countryLine = ''
		if (postal) cityLine += postal + ' '
		if (city) cityLine += city
		if (country && country.length) {
			countryLine = lists.countries.find(c => c.id == country[0]).title
		}

		return [
			address && m('', address),
			cityLine !== '' && m('', cityLine),
			countryLine !== '' && m('', countryLine)
		]
	}
}
